<app-dashboard-stats-card [title]="'Not Interested'" subtitle="Packages that contain a 'Not Interested' response."
                          [count]="getPackageCount()" [routerLink]="'/my-packages'" [queryParams]="{ open: true, open_o: 'is', notInterested: true, notInterested_o: 'is' }" />
